var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showContent)?_c('ur-system',[(_vm.isLoginPage)?_c('auth-layout'):_c('layout'),_c('snackbar-message')],1):_vm._e(),(_vm.getPageLoader)?_c('page-loader'):_vm._e(),_c('auto-logout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }